export const LOCALSTORAGE_KEYS = {
  PARKED_CUSTOMER_CART: 'parked_customer_cart',
  CUSTOMER_POSTALCODE: 'rc_postCode',
  REGIONAL_INDEXES_CONFIG: 'regionalIndexesConfig',
  MARKETING_BANNER_DISMISSED_KEY: 'marketingBannerDismissedAt',
  MARKETING_MODAL_DISMISSED_KEY: 'marketingModalDismissedAt'
} as const

export const SESSIONSTORAGE_KEYS = {
  MARKETING_REMINDER_SUPPRESSED: 'marketingReminderSuppressedInSession'
} as const

export const COOKIES_KEYS = {
  SHIPPING_POSTALCODE: 'dw_shippostalcode',
} as const
